module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/bg_nagai01_bottom-235dedf1cd1d7ec3fefd05ebde12fbf5.jpg";